import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import localeText from "../../../../locale";
import useWeb3 from "./hooks/useWeb3";
import Web3Services from "./hooks/web3Services";

import { InputText } from "primereact/inputtext";
import { SelectButton } from "primereact/selectbutton";

const Web3Dashboard = () => {
  const toast = useRef(null);
  const [valueExc, setValueExc] = useState(0)
  const [destinyAddress, setDestinyAddress] = useState('')
  const [currency, setCurrency] = useState('EXC')


  // const { walletAddress, cryptoBalance, loginWeb3Auth, logoutWeb3Auth, isLoadingInit, isLogged, simplifiedTransaction } = useWeb3();

  const { walletAddress, cryptoBalance, connectWallet, sendTransaction, isLogged } = Web3Services()

  const sendWeb3Transaction = async () => {
    try {
      console.log('simplified transaction')
      await sendTransaction(valueExc,currency, destinyAddress)
    } catch (e) {
      console.log(e)
      toast.current.show({
        severity: "error",
        summary: localeText("error"),
        detail: e.data.message,
        life: 4000,
      })
    }
  }

  // console.log('provider: ' ,provider)
  // console.log('web3auth: ', web3auth)
  // console.log('walletAddress: ', walletAddress)
  // console.log('privateKey: ', privateKey)
  // console.log('cryptoUser: ', cryptoUser)
  // console.log('cryptoBalance: ', cryptoBalance)
  //console.log('isLoadingInit: ', isLoadingInit)
  return (
    <>
      <div className="layout-dashboard">
        <Toast ref={toast} />
        <h3 style={{ paddingLeft: "7px" }}>CriptoWallet</h3>

        <div className="flex flex-column">
          <div className="flex flex-wrap">
            <div className="w-3 col sm:w-full" style={{ minWidth: "15em" }}>
              <div className="overview-box sales" style={{ minHeight: "17em" }}>
                <i className="overview-icon pi pi-wallet"></i>
                <span className="overview-title">
                  <b>Wallet</b>
                </span>
                <div className="overview-numbers">
                  <ul className="list-none p-0 mb-0">
                    <li
                      style={{
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {localeText("publicKey")}: {walletAddress}
                    </li>
                  </ul>
                </div>
                <Button
                  label={localeText("copy")}
                  icon="pi pi-link"
                  iconPos="right"
                  style={{ color: "white" }}
                  className="p-2 p-button-rounded p-button-outlined button-check-statement"
                  onClick={() => {
                    navigator.clipboard.writeText(walletAddress);
                    toast.current.show({
                      severity: "info",
                      summary: localeText("copied"),
                      detail: localeText("copiedToClipboard"),
                      life: 6000,
                    });
                  }}
                />
              </div>
            </div>

            <div className="w-3 col sm:w-full" style={{ minWidth: "15em" }}>
              <div className="overview-box users" style={{ minHeight: "17em" }}>
                <i className="overview-icon pi pi-bitcoin"></i>
                <span className="overview-title">
                  <b>EXTRACOIN</b>
                </span>
                <div className="overview-numbers">
                  <ul className="list-none p-0 mb-0">
                    <li>
                      {localeText("balance")}: {cryptoBalance} {"EXC"}
                    </li>
                  </ul>
                </div>
              </div>

            </div>
          </div>
          <div>
            {
              (isLogged) ? <>
                {/* <div>
                  <Button
                    label={localeText("disconnectWallet")}
                    onClick={logoutWeb3Auth}
                    className="mt-4"
                  />
                </div> */}

                <div>
                  <div className="mb-1 mt-1">
                    <div>
                      {localeText('amount')}
                    </div>
                    <InputText
                      value={valueExc}
                      onChange={(e) => setValueExc(e.target.value)}
                      name="value"
                      className="mb-4"

                    />
                    <SelectButton
                      value={currency}
                      onChange={(e) => setCurrency(e.value)}
                      options={[
                        'EXC',
                        'BRL',
                        'EUR',
                        'USD'
                      ]}
                      className="mb-4"

                    />
                  </div>
                  <div className="">
                    <div>
                      {localeText('destinyWallet')}
                    </div>
                    <InputText
                      value={destinyAddress}
                      onChange={(e) => setDestinyAddress(e.target.value)}
                      name="destinyAddress"
                    />
                  </div>
                </div>
                <Button
                  label={localeText("sendTransaction")}
                  onClick={sendWeb3Transaction}
                  className="mt-4 mr-4"
                />
                <Button
                  label={localeText("refreshAccount")}
                  onClick={connectWallet}
                  className="mt-4 mr-4"
                />
              </> : <>
                <Button
                  label={localeText("accessWallet")}
                  onClick={connectWallet}
                  className="mt-4 mr-4"
                />
              </>
            }
          </div>
        </div>
      </div>
    </>
  );
};

export default Web3Dashboard;
